import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { withApollo, compose } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import {
  createNews,
  deleteNews,
  fetchNewsList,
  updateNews
} from '../../modules/news'

import {
  message,
  Card,
  Table,
  Divider,
  Popconfirm,
  Button,
  Input,
  Icon,
  Tag
} from 'antd'

import { useDeepEffect } from '../../utils/hooks'
import _ from 'lodash'
import Highlighter from 'react-highlight-words'
import NewsForm from './components/NewsForm'

const News = () => {
  const dispatch = useDispatch()
  let searchInput = useRef(null)
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})
  const [searchText, setSearchText] = useState('')

  const { newsItem, isLoading } = useSelector(
    (state) => ({
      newsItem: state.news.newsList,
      isLoading: state.news.isLoading
    }),
    []
  )

  const GetStatusColor = (status) => {
    let color = ''
    switch (status) {
      case true:
        color = 'green'
        break
      case false:
        color = 'red'
        break

      default:
        break
    }
    return color
  }

  useDeepEffect(() => {
    async function fetch() {
      await dispatch(fetchNewsList())
    }

    fetch()
  }, [])

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select())
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  })

  const handleSearch = (selectedKeys, confirm) => {
    confirm()
    setSearchText(selectedKeys[0])
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const refetchData = async () => { }

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }
  const onCloseModal = async () => {
    await dispatch(fetchNewsList())
    await setVisible(false)
  }

  const onOk = async (data) => {
    if (!_.isEmpty(formData)) {
      await dispatch(updateNews(data))
    } else {
      await dispatch(createNews(data))
    }

    await dispatch(fetchNewsList())
    await setVisible(false)
    await setFormData({})
  }

  const onDelete = async (id) => {
    await dispatch(deleteNews(id))
    await dispatch(fetchNewsList())
  }
  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'position',
      key: 'position',
      width: 100,
    },
    {
      title: 'หัวข้อข่าว',
      dataIndex: 'name',
      key: 'name',
      ...getColumnSearchProps('name'),
      render: (name, row) => (
        <div>
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={name.toString()}
          />
        </div>
      )
    },
    {
      title: 'URL',
      dataIndex: 'url',
      key: 'url',
      ...getColumnSearchProps('url'),
      render: (text, record) => {
        return <a href={record.url}>{record.url}</a>
      }
    },
    {
      title: 'Status',
      dataIndex: 'enabled',
      key: 'enabled',
      filters: [
        { text: 'ENABLED', value: true },
        { text: 'DISABLED', value: false }
      ],
      onFilter: (value, record) => record.enabled === value,
      render: (enabled) => {
        const color = GetStatusColor(enabled)
        return (
          <span>
            <Tag color={color} key={enabled}>
              {enabled ? 'Enabled' : 'Disabled'}
            </Tag>
          </span>
        )
      }
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  return (
    <Card
      title="News"
      extra={
        <div>
          <Button size="small" icon="plus" onClick={(e) => onClick(e)}>
            Create News
          </Button>
          <Button size="small" icon="reload" onClick={() => refetchData()}>
            Reload
          </Button>
        </div>
      }>
      <Table
        loading={isLoading}
        scroll={{ x: 1000 }}
        rowKey={(record) => record.id}
        dataSource={newsItem}
        columns={columns}
      />
      <NewsForm
        visible={visible}
        onOk={onOk}
        onCancel={onCloseModal}
        formData={formData}
      />
    </Card>
  )
}


News.propTypes = {
  data: PropTypes.object.isRequired,
  DeleteNews: PropTypes.func.isRequired,
  CreateNews: PropTypes.func.isRequired,
  UpdateNews: PropTypes.func.isRequired
}

export default compose(
  withApollo
)(News)
